import axios from "axios";

export const state = {
    schoolterms: [],
};

export const getters = {
    schoolterms: state => state.schoolterms,
};

export const mutations = {
    setTerms(state, newValue) {
        state.schoolterms = newValue
    },
};

export const actions = {
    fetchSchoolTerms({ commit }) {
        axios.get('/schoolterms').then(res => {
            commit('setTerms', res.data.schoolterms);
        })
    },
};
